module.exports = __webpack_public_path__ + "static/media/historic_icsp_marker.836d2ee5.svg";